import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceForecastDetail from "@/pages/IntelligenceEventDetail";

export const Route = createFileRoute("/_app/intelligence/forecasts/$id")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceForecastDetail /></PageGate>
  ),
});
